(function () {

	var $productVariantDD = $('#ID'),
		$slideChangers = $('[data-slide]'),
		productImageSwiper = new Swiper('#product-images .swiper-container', {
        loop: false,
        thumbs: {
            swiper: {
                el: '#product-thumbs .swiper-container',
                slidesPerView: 4,
                navigation: {
                    nextEl: '#product-thumbs .swiper-button-next',
                    prevEl: '#product-thumbs .swiper-button-prev',
                },
            }
        },
		on: {
			slideChange: function () {

				// Look for a product variant option in the dropdown linked to this slide.
				var matchingProductVariantOption = $productVariantDD.find('option[data-slide="' + this.realIndex + '"]');

				// If we found an option and it's not disabled, select it as the dropdown's value.
				if (matchingProductVariantOption.length > 0 && !matchingProductVariantOption.is(':disabled')) {
					$productVariantDD.val(matchingProductVariantOption.val());
				} else {
					$productVariantDD.val('');
                }
            }
        }
    });

	$slideChangers.click(function (e) {
        productImageSwiper.slideTo($(this).data('slide'));
    });

	$productVariantDD.on('change', function (e) {

        var $dropdown = $(this),
            swiperSlideIndex = $dropdown.find('option[value="' + $dropdown.val() + '"]').data('slide');

        if (swiperSlideIndex !== undefined) {
            productImageSwiper.slideTo(swiperSlideIndex);
        }

    });

})();

(function () {

	var $stockAlertFields = $('#stock-alert-fields'),
		$stockAlertTitle = $('#stock-alert-title'),
		$stockAlertFooter = $('#stock-alert-footer'),
		$stockAlertMessage = $('#stock-alert-message'),
		$stockAlertEmail = $('#stock-alert-email'),
		$stockAlertEmailValidation = $('span[data-valmsg-for="' + $stockAlertEmail.attr('name') + '"]'),
		$stockAlertVariant = $('#stock-alert-variant-id');

	function resetStockNotificationForm(e) {
		$stockAlertEmail.removeClass('input-validation-error').val('');
		$stockAlertEmailValidation.text('');
		$stockAlertFields.show();
		$stockAlertFooter.show();
		$stockAlertMessage.html('');
	}

	function setupStockNotificationForm(e) {
		var $stockAlertBtn = $(e.relatedTarget);
		$stockAlertTitle.text($stockAlertBtn.data('stock-alert-product'));
		$stockAlertVariant.val($stockAlertBtn.data('stock-alert-id'));
	}

	window.onBeginStockAlert = function (xhr, ajax) {
		$stockAlertMessage.html('');
	};

	window.onSuccessfulStockAlert = function (data, status, xhr) {
		$stockAlertFields.hide();
		$stockAlertFooter.hide();
		$stockAlertMessage.html('<div class="alert alert-success mb-0"><p class="mb-0">' + data + '</p></div>');
	};

	window.onFailedStockAlert = function (xhr, status, error) {
		$stockAlertMessage.html('<div class="alert alert-danger"><p class="mb-0">An error occurred whilst subscribing your for stock notifications. Please try again.</p></div>');
	};

	// Bind setup process when the modal is about to be shown.
	$(document).on('show.bs.modal', setupStockNotificationForm);

	// Bind cleanup process when the modal is hidden.
	$(document).on('hidden.bs.modal', resetStockNotificationForm);

})();


(function () {

	var hash = location.hash;

	if (hash.length > 0 && hash.indexOf("#") > -1) {
		$('#features-tab').removeClass("active");
		$('#spec-tab').removeClass("active");
		$('#documents-tab').removeClass("active");
		$('#videos-tab').removeClass("active");

		$('#features').removeClass("active");
		$('#spec').removeClass("active");
		$('#documents').removeClass("active");
		$('#videos').removeClass("active");

		$('#features').addClass("fade");
		$('#spec').addClass("fade");
		$('#documents').addClass("fade");
		$('#videos').addClass("fade");
		var valid = false;

		if (hash == "#videos" && $('#videos-tab').length > 0) {
				$('#videos-tab').addClass("active");
				$('#videos').addClass("active");
				$('#videos').removeClass("fade");
				valid = true;
		}
		else if (hash == "#spec" && $('#spec-tab').length > 0) {
				$('#spec-tab').addClass("active");
				$('#spec').addClass("active");
				$('#spec').removeClass("fade");
				valid = true;
		}
		else if (hash == "#features" && $('#features-tab').length > 0) {
				$('#features-tab').addClass("active");
				$('#features').addClass("active");
				$('#features').removeClass("fade");
				valid = true;
		}
		else if (hash == "#documents" && $('#documents-tab').length > 0) {
				$('#documents-tab').addClass("active");
				$('#documents').addClass("active");
				$('#documents').removeClass("fade");
				valid = true;
		}
		else {
			$('#spec-tab').addClass("active");
			$('#spec').addClass("active");
			$('#spec').removeClass("fade");
		}

		if (valid) {
			$('html, body').animate({
				scrollTop: $('#sectionTabs').offset().top -70
			}, 1000);
		}
	}
	else {
		$('#spec-tab').addClass("active");
		$('#spec').addClass("active");
		$('#spec').removeClass("fade");
	}

	var $techSpecPanelBtns = $('#spec-table button[data-toggle-panel]');


	function toggleTechSpecPanel() {

		var $btn = $(this);

		// Swap the icon class for the expand/collapse button.
		if ($btn.hasClass('fa-minus')) {
			$btn.removeClass('fa-minus').addClass('fa-plus');
		} else {
			$btn.removeClass('fa-plus').addClass('fa-minus');
        }

		// Hide all the child table cells in the current row except the first one.
		$btn.closest('tr').find('td:not(:first-child').toggleClass('d-none');

	}

	$techSpecPanelBtns.on('click', toggleTechSpecPanel);

})();

window.addEventListener('load', function () {

	function initMasonry() {

		// Configure the masonry plugin.
		$('#gallery').masonry({
			"percentPosition": true,
		});

	}

	// Generate a script reference to the masonry library.
	var masonryScript = document.createElement("script");
	masonryScript.src = "https://cdn.jsdelivr.net/npm/masonry-layout@4.2.2/dist/masonry.pkgd.min.js";
	masonryScript.integrity = "sha384-GNFwBvfVxBkLMJpYMOABq3c+d3KnQxudP/mGPkzpZSTYykLBNsZEnG2D9G/X/+7D";
	masonryScript.crossOrigin = "anonymous";
	masonryScript.async = true;
	masonryScript.defer = true;
	masonryScript.addEventListener("load", initMasonry);

	// Add the script element to the head of the document.
	document.head.appendChild(masonryScript);

});